import React, { ReactNode } from 'react';

type ModalTextRowProps = {
    text: string;
    leftIcon?: ReactNode;
    rightIcon?: ReactNode;
    onClick: (ev: React.MouseEvent<HTMLDivElement>) => void;
};

const ModalTextRow = ({
    text,
    leftIcon,
    rightIcon,
    onClick,
}: ModalTextRowProps) => {
    return (
        <div
            className="flex flex-row items-center justify-between py-3 pl-3 pr-2 bg-white my-1 rounded-lg cursor-pointer hover:text-primary-700"
            onClick={onClick}
        >
            {leftIcon}
            <div className={`flex${leftIcon ? ' pl-8' : ''}`}>
                <span className="">{text}</span>
            </div>
            {rightIcon}
        </div>
    );
};
export default ModalTextRow;
